import React from "react";
import { TextInput, required } from 'react-admin';
import { GridForm, GridInput } from '../../../components/GridForm';
import { SelectEnumInput } from "components/inputs/SelectEnumInput";
import { NotificationSubscriptionEventType } from "entities/NotificationSubscriptionEventType";
import { ThirdPartyInput } from "components/inputs/ThirdPartyInput";

  
export const ClientNotificationSubscriptionForm = props => (
	<GridForm {...props}>
		<GridInput xs={12} sm={6} component={ThirdPartyInput} validate={required()} source="oauth2_client_id" autoFocus />
		<GridInput xs={12} sm={6} component={TextInput} validate={required()} source="callback_url" />
		<GridInput xs={12} sm={6} component={SelectEnumInput} validate={required()} source="event_type" 
			enumObj={NotificationSubscriptionEventType} enumName="notification_subscription" resettable />
	</GridForm>
);
